import React, { useState } from "react";
import { Box, Button, Menu, MenuItem, ListItemText } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { widgetOptions } from "src/utils/widgetOptions";

export default function AddWidgetButton({ onAddWidget }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (widgetType) => {
    onAddWidget(widgetType);
    handleClose();
  };

  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddCircleIcon fontSize="small" />}
        onClick={handleClick}
        aria-controls={open ? "add-widget-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        Add New Widget
      </Button>

      <Menu
        id="add-widget-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "add-widget-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {widgetOptions.map((option) => (
          <MenuItem
            key={option.type}
            onClick={() => handleMenuItemClick(option.type)}
          >
            {/* <ListItemIcon>{option.icon}</ListItemIcon> */}
            <ListItemText>{option.name}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
